import ENUM from '@/enums/enums';

export default {
  apiState: ENUM.INIT,
  users: [],
  authenticated: false,
  user: null,
  userToken: null, // jwt
  boToken: null,
};
